export default __webpack_public_path__ + "static/media/litecoin.51052ef6.svg";